/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function HardHatIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="hard-hat"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.5 17.75C2.5 16.784 3.284 16 4.25 16L19.75 16C20.716 16 21.5 16.784 21.5 17.75C21.5 18.716 20.716 19.5 19.75 19.5L4.25 19.5C3.284 19.5 2.5 18.716 2.5 17.75Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10 6C10 4.895 10.895 4 12 4C13.105 4 14 4.895 14 6L14 9.5C14 10.605 13.105 11.5 12 11.5C10.895 11.5 10 10.605 10 9.5L10 6Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14 6A7.716 7.716 0 0 1 19.75 16" data-tinysvg-shape="arc" data-tinysvg-arc="12.431 13.555 7.716 7.716 281.729 378.473 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M4.25 16A7.716 7.716 0 0 1 10 6" data-tinysvg-shape="arc" data-tinysvg-arc="11.569 13.555 7.716 7.716 161.527 258.271 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
